import { render, staticRenderFns } from "./fotoLainnya.vue?vue&type=template&id=b0e51076&"
import script from "./fotoLainnya.vue?vue&type=script&lang=js&"
export * from "./fotoLainnya.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports